/**
 * MDXContent component for rendering compiled MDX with React components
 */

import { useEffect, useState } from 'react';
import { run } from '@mdx-js/mdx';
import * as runtime from 'react/jsx-runtime';
import { MDXComponents } from './MDXComponents';

interface MDXContentProps {
  code: string;
  className?: string;
}

export function MDXContent({ code, className = '' }: MDXContentProps) {
  const [MDXModule, setMDXModule] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadMDX() {
      try {
        const module = await run(code, {
          ...runtime,
          baseUrl: import.meta.url,
        });
        setMDXModule(module);
      } catch (err) {
        console.error('Failed to load MDX:', err);
        setError(err instanceof Error ? err.message : 'Failed to load content');
      }
    }

    loadMDX();
  }, [code]);

  if (error) {
    return (
      <div className={className}>
        <p className="text-red-500">Error loading content: {error}</p>
      </div>
    );
  }

  if (!MDXModule) {
    return (
      <div className={className}>
        <p className="text-gray-400">Loading content...</p>
      </div>
    );
  }

  const { default: MDXContent } = MDXModule;

  return (
    <div className={className}>
      <MDXContent components={MDXComponents} />
    </div>
  );
}
